module.exports = __webpack_public_path__ + "static/media/IMG-7.b55f5a73.jpg";